import { Col, Container, Row } from "react-bootstrap";
import PropertyAmenityForm from "../../../Components/Forms/PropertyAmenityForm/PropertyAmenityForm";
import { navigateTo } from "../../../redux/router/routerActions";
import { useAppDispatch } from "../../../redux/store";
import { useEditPropertyAmenityMutation, useGetPropertyAmenityByIdQuery } from "../../../services/bClientApi";
import { useParams } from "react-router-dom";
import useMyProperties from "../../../Hooks/UseMyProperties/UseMyPropertiesHook";
import useMyPropertiesSelectValues from "../../../Hooks/UseMyProperties/UseMyPropertySelectValuesHook";
import useAmenitySelectValues from "../../../Hooks/UseAmenities/useAmenitySelectValuesHook";

export default function EditPropertyAmenityPage() {

    const { propertyAmenityId = '' } = useParams()

    const {
        data,
        error,
        isLoading
    } = useGetPropertyAmenityByIdQuery(propertyAmenityId, { skip: !propertyAmenityId })
    const propertyAmenityData = data || {}

    const [
        editPropertyAmenity,
        {
            isLoading: isLoadingEdit,
            error: editError
        }
    ] = useEditPropertyAmenityMutation()

    const { myProperties } = useMyProperties()
    const propertyOptions = useMyPropertiesSelectValues(myProperties)
    const amenityOptions = useAmenitySelectValues()

    const dispatch = useAppDispatch()
    const handleSubmit = async (data: any) => {
        const values: any = {
            ...data
        }
        const updatedPropertyAmenity = await editPropertyAmenity({
            propertyAmenityId: propertyAmenityId,
            propertyAmenityInfo: values
        }).unwrap()
        if (updatedPropertyAmenity._id) {
            dispatch(navigateTo(`/property-amenity/${updatedPropertyAmenity._id}`))
        }
        return updatedPropertyAmenity
    }

    return (
        <Container>
            <Row>
                <Col>
                    <h1>Edit Property Amenity</h1>
                    <hr />
                    {error && (<>{JSON.stringify(error)}<br /></>)}
                    {editError && (<>{JSON.stringify(editError)}<br /></>)}

                    {propertyAmenityId && propertyAmenityData && !isLoading && (
                        <PropertyAmenityForm
                            initialValues={{
                                ...propertyAmenityData,
                            }}
                            disabled={isLoading || isLoadingEdit}
                            onSubmit={handleSubmit}
                            propertyOptions={propertyOptions}
                            amenityOptions={amenityOptions}
                        />
                    )}

                </Col>
            </Row>
        </Container>
    )
}
